import type { Lightbox } from '../..';

let loading: Promise<typeof Lightbox> | undefined;

/**
 * A lightbox starts closed and is never server-rendered, so callers import it
 * on demand: prefetch on pointer/focus of the opener, then render it once this
 * resolves. A failed import is forgotten so the next attempt retries it.
 *
 * Callers must take `GalleryMedia`/`GalleryItem` from `Lightbox/types` rather
 * than the `Lightbox` index: a static import of the index keeps the component
 * in the page's bundle.
 */
export const loadLightbox = () => {
	loading ??= import('./lazyLightbox')
		.then((module) => module.Lightbox)
		.catch((error) => {
			loading = undefined;
			throw error;
		});

	return loading;
};
